import AxiosServices from "./AxiosService";

const Auth = new AxiosServices();


class AuthenticationService {

    signup = async (authentication) => {
        return Auth.post('/auth/signup', authentication)
    };

    signin = async (authentication) => {
        return Auth.post('/auth/login/step1', authentication)
    }

    VerifyOtp = async (otp) => {
        return Auth.post('/auth/login/step2', otp)
    }

    VerifyOtp2 = async (email) => {
        return Auth.post('/auth/verify-otp', email)
    }

    ResendOtp = async (otp) => {
        return Auth.post('/auth/resend-otp', otp)
    }

    getProfile = async () => {
        return Auth.get('/auth/profile')
    }

}

export default AuthenticationService

